import { YuLifeLocale } from "@hooks";
import { removeDuplicatesFromObjectArrayByProperty } from "@utils";
import { Reward, RewardCountry } from "components/pages/GlobalRewards/types";
import { RegionalReward } from "components/atoms/RewardCard";
import { getFallbackRewards } from "data/rewards";

const IMPORTANT_REWARDS = [
  "Nike",
  "Apple",
  "Amazon",
  "Amazon UK",
  "Amazon US",
  "Starbucks",
  "ODEON",
  "Garmin",
  "Fitbit",
  "charity: water",
  "Earthly",
];

const BASE_REWARDS_JP = [
  "Plant trees with Earthly",
  "Earthly",
  "Polar",
  "Fight world hunger with ShareTheMeal",
  "ShareTheMeal",
  "Meditopia",
  "Sleep Cycle",
];

export const sanitiseMapRewards = (rewards: Reward[], countryId?: string) => {
  const filteredRewardsWithoutImages = rewards.filter((item) => item.listItemImage);
  const duplicatesRemoved = removeDuplicatesFromObjectArrayByProperty(
    filteredRewardsWithoutImages,
    "name",
  );

  // Temporary hack to remove certain rewards in Japan - this is bad
  // Apparently urgent
  // We will provide Jamie a proper way to manage this in the internal dashboard

  if (countryId === "JP") {
    const removeJapaneseRewards = duplicatesRemoved.filter((reward) =>
      BASE_REWARDS_JP.includes(reward.name),
    );

    return prioritiseImportantRewards(removeJapaneseRewards, "name", IMPORTANT_REWARDS);
  }

  return prioritiseImportantRewards(duplicatesRemoved, "name", IMPORTANT_REWARDS);
};

export const sanitiseListOfMapRewardCountries = (rewardCountries: RewardCountry[]) => {
  if (rewardCountries.some((country) => country.countryCode === "US")) {
    rewardCountries.push({ countryCode: "US-main", countryName: "United States" });
  }

  return rewardCountries.sort((a, b) => (a.countryName < b.countryName ? -1 : 1));
};

export const sanitiseRewards = (rewards: RegionalReward[], locale: YuLifeLocale) => {
  let sanitisedRewards = (rewards || [])
    .filter((reward) => reward._id && reward.heading && reward.description && reward.image)
    .sort((a, b) => a.heading.localeCompare(b.heading));

  if (sanitisedRewards.length === 0) {
    rewards = getFallbackRewards(locale);
  }

  // adding in the below to filter out rewards on the JP site that have English-only descriptions
  // this is due to the website tab on Internal Dashboard not having localisation options
  // will address that in the long term but this is the quick solution

  if (locale === "jp") {
    sanitisedRewards = sanitisedRewards.filter((reward) => isJapanese(reward.description));
  }

  return prioritiseImportantRewards(sanitisedRewards, "heading", IMPORTANT_REWARDS);
};

export const prioritiseImportantRewards = <T>(
  rewards: T[],
  propertyName: "name" | "heading",
  importantRewards: string[],
) => {
  return rewards.sort((reward) => {
    return importantRewards.includes(reward[propertyName].trim()) ? -1 : 1;
  });
};

const isJapanese = (text: string) => {
  return /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF]/.test(text);
};
